var _linearGradient, _style;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStripeButton(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 130",
    width: 130,
    height: 130,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs204"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4907"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#764de8",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop4903"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#6772e5",
      stopOpacity: 1
    },
    offset: 1,
    id: "stop4905"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    href: "#linearGradient4907",
    id: "linearGradient4909",
    x1: 24.202744,
    y1: 51.679764,
    x2: 152.20274,
    y2: 179.67976,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-23.202743,41.820238)"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style183"
  }, "\n    .st0{fill-rule:evenodd;clip-rule:evenodd;fill:#6772E5;}\n  ")), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    style: {
      display: "inline"
    },
    transform: "translate(0,-92.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "url(#linearGradient4909)",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#000000",
      strokeWidth: 0.72299999,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 0
    },
    id: "rect218",
    width: 128,
    height: 128,
    x: 1,
    y: 93.5,
    ry: 14.273413
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipRule: "evenodd",
      display: "inline",
      fill: "#ffffff",
      fillRule: "evenodd"
    },
    id: "path197",
    d: "m 58.550002,139.09998 c 0,-3.9 3.2,-5.4 8.5,-5.4 7.6,0 17.199997,2.30001 24.799997,6.4 V 116.6 c -8.3,-3.3 -16.499997,-4.6 -24.799997,-4.6 -20.3,0 -33.8,10.6 -33.8,28.3 0,27.60001 38,23.20001 38,35.10001 0,4.6 -4,6.1 -9.6,6.1 -8.3,0 -18.9,-3.40002 -27.3,-8 v 23.8 c 9.3,4 18.7,5.7 27.3,5.7 20.799997,0 35.099997,-10.30002 35.099997,-28.2 C 96.649999,145 58.550002,150.3 58.550002,139.09998 Z",
    className: "st0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripeButton);
export default __webpack_public_path__ + "static/media/StripeButton.4473055345574544056c1bdedf511332.svg";
export { ForwardRef as ReactComponent };